import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { OtherApplicationsStyle } from "./style";
var OtherApplications = function OtherApplications(_ref) {
  var show_ids = _ref.show_ids,
    applications = _ref.applications,
    onOpen = _ref.onOpen,
    loading = _ref.loading;
  return /*#__PURE__*/React.createElement(OtherApplicationsStyle, {
    label: "Other Applications",
    onChange: onOpen
  }, /*#__PURE__*/React.createElement("ul", null, loading ? /*#__PURE__*/React.createElement("li", null, "Loading... ", /*#__PURE__*/React.createElement(FontAwesome, {
    name: "circle-o-notch",
    spin: true
  })) : applications.length <= 0 ? /*#__PURE__*/React.createElement("li", null, "No other applications") : applications.map(function (_ref2) {
    var id = _ref2.id,
      link = _ref2.link,
      school = _ref2.school,
      program = _ref2.program;
    return /*#__PURE__*/React.createElement("a", {
      key: "other-application-".concat(id),
      href: link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement("li", null, show_ids ? "".concat(id, " | ") : '', school.name, " | ", program.name));
  })));
};
export default OtherApplications;